import PasswordConfiguration from './PasswordConfiguration';

export default PasswordConfiguration;
